module.exports = __webpack_public_path__ + "static/media/le-potager-regal-mobile.9de63a72.png";